export * from "./isInTimeCheck";
export * from "./findPath";
export * from "./extractSourceCodes";
export * from "./postMessage";
export * from "./logger";
export * from "./cookies";
export * from "./treeViewParser";
export * from "./pendingAchievements";
export * from "./isSessionActiveCheck";
export * from "./redirectToLogin";
export * from "./publicProjects";
export * from "./isLocal";
export * from "./isElectronShell";
export * from "./errors";
export * from "./blocklyScreenshot";
export * from "./tabNameUpdate";
export * from "./asyncExecutionQue";
export * from "./sockets";
export * from "./sentryTools";
export * from "./encryptor";
export * from "./yamlUtils";
export * from "./localizeCircleFlowText";
export * from "./godotUrl";

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};